import { render } from "./admin-quize.svg?vue&type=template&id=27f8e9c3"
const script = {}
script.render = render

export default script